module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('transition', {
    attrs: {
      "name": "slide"
    },
    on: {
      "after-leave": _vm.afterLeave
    }
  }, [(_vm.show) ? _c('div', {
    staticClass: "toast-wrap"
  }, [_c('div', {
    class: _vm.componentClass,
    on: {
      "click": _vm.clickHandle
    }
  }, [(_vm.type === 'loading') ? _c('icon', {
    staticClass: "icon rotate",
    attrs: {
      "name": "i-loading",
      "color": '#fff'
    }
  }) : _vm._e(), _vm._v(" "), (_vm.type === 'error') ? _c('icon', {
    staticClass: "icon",
    attrs: {
      "name": "i-close",
      "color": '#fff'
    }
  }) : _vm._e(), _vm._v(" "), _c('div', [_vm._v(_vm._s(_vm.content))])], 1), _vm._v(" "), (_vm.type === 'loading') ? _c('div', {
    staticClass: "mask"
  }) : _vm._e()]) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-96837330"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/_components/public/toast/toast.vue
// module id = 129
// module chunks = 10